export default __webpack_public_path__ + "static/media/splash-image-01.0ba3a98d.png";